import { render } from "./YoubeSingleItem.vue?vue&type=template&id=1f1fedc5&scoped=true"
import script from "./YoubeSingleItem.vue?vue&type=script&lang=js"
export * from "./YoubeSingleItem.vue?vue&type=script&lang=js"

import "./YoubeSingleItem.vue?vue&type=style&index=0&id=1f1fedc5&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1fedc5"]])

export default __exports__